export function lockAchHiddenInputs(host) {
  if (!host) return () => {};

  const apply = () => {
    host.querySelectorAll("input").forEach((el) => {
      if (el.getAttribute("tabindex") !== "-1") {
        el.setAttribute("tabindex", "-1");
      }
    });
  };

  apply();

  if (typeof MutationObserver === "undefined") {
    return () => {};
  }

  const observer = new MutationObserver(apply);
  observer.observe(host, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["tabindex"],
  });

  return () => observer.disconnect();
}
